import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../Footer";
import { get, post, put } from "../../services/Services";
import { useLocation } from "react-router-dom";
import { FaAd, FaDelete, FaPlus, FaSave, FaTimesCircle, FaTrash } from "react-icons/fa";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

function AwardAllocation({ refetch }) {
  const location = useLocation();
  const { eventId, ConfigId } = location.state || {};

  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [availableAwards, setAvailableAwards] = useState([]);

  // Estado para almacenar los premios seleccionados por cada obra (index)
  const [selectedAwards, setSelectedAwards] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Obras a premiar
        const response = await get(`/api/academy/events/${ConfigId}/performances/awards`);
        const data = response.data || response || [];
        setAwards(data);

        // Premios disponibles
        const awardsResponse = await get(`/api/academy/awards?page=0&size=100`);
        const awardsData = awardsResponse.data?.content || [];
        setAvailableAwards(awardsData);

        // Inicializamos los selects por cada obra
        const initialSelections = {};
        data.forEach((item, index) => {
          if (item.awards && item.awards.length > 0) {
            initialSelections[index] = item.awards.map((award) => String(award.id));
          } else {
            initialSelections[index] = [""];
          }
        });
        setSelectedAwards(initialSelections);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      } finally {
        setLoading(false);
      }
    };

    if (ConfigId) {
      fetchData();
    }
  }, [ConfigId]);

  const fetchData = async () => {
    try {
      // Obras a premiar
      const response = await get(`/api/academy/events/${ConfigId}/performances/awards`);
      const data = response.data || response || [];
      setAwards(data);

      // Premios disponibles
      const awardsResponse = await get(`/api/academy/awards?page=0&size=100`);
      const awardsData = awardsResponse.data?.content || [];
      setAvailableAwards(awardsData);

      // Inicializamos los selects por cada obra
      const initialSelections = {};
      data.forEach((item, index) => {
        if (item.awards && item.awards.length > 0) {
          initialSelections[index] = item.awards.map((award) => String(award.id));
        } else {
          initialSelections[index] = [""];
        }
      });

      setSelectedAwards(initialSelections);
    } catch (error) {
      console.error("Error al obtener datos:", error);
    } finally {
      setLoading(false);
    }
  };



  // Función para manejar selección en cada premio
  const handleSelectChange = (awardIndex, selectIndex, value) => {
    const updated = { ...selectedAwards };
    updated[awardIndex][selectIndex] = value;
    setSelectedAwards(updated);
  };

  // Función para agregar un nuevo select a una obra
  const handleAddAward = (awardIndex) => {
    const updated = { ...selectedAwards };
    updated[awardIndex].push(""); // Añade un nuevo select vacío
    setSelectedAwards(updated);
  };

  const handleRemoveAward = (awardIndex, selectIndex) => {
    const updated = { ...selectedAwards };
    // Evita eliminar si queda solo uno
    if (updated[awardIndex].length > 1) {
      updated[awardIndex].splice(selectIndex, 1);
      setSelectedAwards(updated);
    }
  };
  const groupedByScheduleOrder = awards.reduce((acc, item) => {
    const key = item.scheduleOrder;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});


  const handleSaveAwards = async (globalIndex, performanceId) => {
    const selected = selectedAwards[globalIndex]?.filter(Boolean);
    if (!selected || selected.length === 0) return;

    const payload = {
      dancePerformance: { id: performanceId },
      awards: selected.map(id => ({ id: parseInt(id) }))
    };

    try {
      await put(
        `/api/academy/events/${ConfigId}/performances/awards`,
        payload
      );
      toast.success("Premios guardados exitosamente.");
      await fetchData();
      const refreshed = await refetch();
      setAwards(refreshed?.data || []); // <--- Este paso puede ser necesario
    } catch (error) {
      console.error("Error guardando premios:", error);
    }
  };



  return (
    <div className="container mt-4 pb-5">
      <h2 className="text-center mb-5">Asignación de Premios</h2>

      {loading ? (
        <p className="text-center">Cargando premios...</p>
      ) : awards.length > 0 ? (
        Object.entries(groupedByScheduleOrder).map(([scheduleOrder, group]) => (
          <div key={scheduleOrder}>
            <h4 className="mb-3 mt-5 text-secondary text-center">Burbuja {scheduleOrder}</h4>

            {group.map((award, index) => {
              const globalIndex = awards.findIndex((a) => a === award);

              return (
                <div
                  key={globalIndex}
                  className={`border rounded p-2 mb-3 shadow-sm ${award.isChoreographed
                      ? "bg-secondary"
                      : globalIndex % 2 === 0
                        ? "bg-white"
                        : "bg-light"
                    }`}
                >
                  <div className="row align-items-center">
                    {/* Columna 1: Número */}
                    <div className="col-md-1 text-center">
                      <div className="h1 text-dark m-0">{globalIndex + 1}</div>
                    </div>

                    {/* Columna 2: Datos */}
                    <div className="col-md-4">
                      <p className="mb-1">
                        <strong>Modalidad:</strong> {award.modality}
                      </p>
                      <p className="mb-1">
                        <strong>Categoría:</strong> {award.category}
                      </p>
                      <p className="mb-1">
                        <strong>Forma:</strong> {award.participationForm}
                      </p>
                      <p className="mb-1">
                        <strong>Escuela:</strong> {award.school}
                      </p>
                      <p className="mb-1">
                        <strong>Obra:</strong> {award.dancePerformance}
                      </p>
                      <p className="mb-1">
                        <strong>Participantes:</strong>{" "}
                        {award.participationForm.toLowerCase() === "solista"
                          ? award.members
                          : `${award.countParticipants} participantes`}
                      </p>
                    </div>

                    {/* Columna 3: Preparadores */}
                    <div className="col-md-3 text-end">
                      <p className="mb-1">
                        <strong>Preparadores:</strong>
                      </p>
                      <p className="mb-1">
                        {award.preparers &&
                          award.preparers.join(", ")}
                      </p>

                      {award.isChoreographed && (
                        <>
                          <p className="mb-1">
                            <strong>Coreógrafos/as:</strong>
                          </p>
                          <p className="mb-1">
                            {award.choreographers?.join(", ")}
                          </p>
                        </>
                      )}

                    </div>

                    {/* Columna 4: Selects y botón */}
                    <div className="col-md-4 text-end">
                      <div className="d-flex flex-column align-items-center">
                        {selectedAwards[globalIndex] &&
                          selectedAwards[globalIndex].map((selected, selectIdx) => (
                            <div
                              key={selectIdx}
                              className="d-flex align-items-center mb-2"
                            >
                              <select
                                className="form-select"
                                style={{ width: "200px" }}
                                value={selected}
                                onChange={(e) =>
                                  handleSelectChange(
                                    globalIndex,
                                    selectIdx,
                                    e.target.value
                                  )
                                }
                              >
                                <option value="">Seleccionar premio...</option>
                                {availableAwards.map((award) => (
                                  <option key={award.id} value={award.id}>
                                    {award.name}
                                  </option>
                                ))}
                              </select>

                              {selectedAwards[globalIndex].length > 1 && (
                                <button
                                  onClick={() =>
                                    handleRemoveAward(globalIndex, selectIdx)
                                  }
                                  className="btn btn-sm p-0 ms-2"
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    backgroundColor: "transparent",
                                    border: "none",
                                    cursor: "pointer",
                                  }}
                                  type="button"
                                >
                                  <FaTrash color="red" />
                                </button>
                              )}
                              <button
                                onClick={() => handleSaveAwards(globalIndex, award.dancePerformanceId)}
                                className={`btn btn-sm ms-2 ${award.awards && award.awards.length > 0 ? "btn-danger" : "btn-success"
                                  }`}
                                type="button"
                              >
                                <FaSave />
                              </button>

                            </div>
                          ))}

                        <button
                          onClick={() => handleAddAward(globalIndex)}
                          className="btn btn-primary d-flex justify-content-center align-items-center p-0"
                          style={{ width: "38px", height: "38px" }}
                          type="button"
                        >
                          <FaPlus />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ))
      ) : (
        <p className="text-center">No hay premios para mostrar.</p>
      )}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>

  );


};

export default AwardAllocation;
